import gsap, { Power3 } from "gsap";

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from "../_app/cuchillo/core/Element";
import { ScrollItem__Default } from './ScrollItem__Default';

class ScrollItem__Marquee extends ScrollItem__Default {
    _samples;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setUpAnimation();
    }

    setUpAnimation() {
        this._samples = GetBy.class('sample', this.item);
        gsap.set(this._samples, { y: '110%' });
    }

    showAnimation() {
        super.showAnimation();
        gsap.to(this._samples, { y: 0, duration: .8, ease: Power3.easeOut });
    }
}

Scroll._registerClass('Marquee', ScrollItem__Marquee);
